import {BaseWidget} from "./BaseWidget";
import * as EditScreenFieldLayout from "../constants/EditScreenFieldLayout";

export class LongTextWidget extends BaseWidget {
    constructor(req, layout) {
        super(req);
        this.layout = layout;
    }

    createElement(style) {
        let that = this;
        let textArea = $(`<textarea class="k-textbox w-100" ${style} id="${that.elementId}" nid="${that.id}">`);
        if (that.layout && that.layout === EditScreenFieldLayout.spanned2)
            textArea.attr('rows', '8');
        return textArea;
    }
}